import { FORM_TYPE } from "../../constants/custom-define-type";
import { TEXTBOX_INPUT_TYPE } from "../../constants/custom-define-type";
import { SERVICE_TYPE } from "../../constants/employer";

const genders = ["Male", "Female", "Other"];

const americanStates = [
  "AL",
  "AK",
  "AS",
  "AZ",
  "AR",
  "CA",
  "CO",
  "CT",
  "DE",
  "DC",
  "FM",
  "FL",
  "GA",
  "GU",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MH",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "NE",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "MP",
  "OH",
  "OK",
  "OR",
  "PW",
  "PA",
  "PR",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VT",
  "VI",
  "VA",
  "WA",
  "WV",
  "WI",
  "WY",
];

const childrenListFieldsBase = [
  { label: "First Name: *", model: "first_name", itemPerRow: 2 },
  { label: "Last Name: ", model: "last_name", itemPerRow: 2, isRequired: false, },
  {
    label: "Gender:",
    model: "gender",
    type: FORM_TYPE.DROPDOWN,
    optionList: genders,
    itemPerRow: 2,
    isRequired: false
  },
  {
    label: "Birth date: ",
    model: "birthday",
    type: FORM_TYPE.DATEPICKER,
    itemPerRow: 2,
    isRequired: false,
  }
];

const state = {
  employerStatuses: [
    "Pre Application",
    "Applied",
    "Inactive",
    "Application Approved",
    "Welcome Call Complete",
    // "Package Selected",
    "Payment Info Entered",
    "Documents Signed",
    // 'Consultation Booked',
    // "Consultation Complete",
    "Active",
    "Nanny Assigned",
    "Lost",
    "Placement Fee Paid"
  ],
  childrenListFieldsNewBorn: [
    ...childrenListFieldsBase,
    {
      type: FORM_TYPE.TEXTAREA,
      label: "Personality, interests and hobbies? ",
      isRequired: false,
      model: "text1",

    },
    {
      type: FORM_TYPE.TEXTAREA,
      label: "Any special needs, dietary restrictions or allergies? *",
      model: "text2"
    }
  ],
  childrenListFieldsSitter: [
    ...childrenListFieldsBase,
    {
      type: FORM_TYPE.TEXTAREA,
      label: "Personality, interests and hobbies? ",
      isRequired: false,
      model: "text1"
    },
    {
      type: FORM_TYPE.TEXTAREA,
      label: "Any special needs, dietary restrictions or allergies? *",
      model: "text2"
    }
  ],
  childrenListFieldsNanny: [
    ...childrenListFieldsBase,
    {
      type: FORM_TYPE.TEXTAREA,
      label: "Personality, interests and hobbies ",
      isRequired: false,
      model: "text1"
    },
    {
      type: FORM_TYPE.TEXTAREA,
      label: "Any special needs, dietary restrictions or allergies? *",
      model: "text2"
    },
    {
      type: FORM_TYPE.TEXTAREA,
      label: "Any fears that need to be noted?",
      isRequired: false,
      model: "text3"
    }
  ],
  childrenListFieldsPrivateEducator: [
    ...childrenListFieldsBase,
    {
      type: FORM_TYPE.TEXTBOX,
      label: "Grade Level ",
      model: "text3",
      isRequired: false,
    },
    {
      type: FORM_TYPE.TEXTAREA,
      label: "Personality, interests and hobbies ",
      model: "text1",
      isRequired: false,
    },
    {
      type: FORM_TYPE.TEXTAREA,
      label: "Any special needs, dietary restrictions or allergies? *",
      model: "text2",
    }
  ],
  familyInformationListFields: [
    {
      label: "Type of Service Needed: *",
      type: FORM_TYPE.RADIO,
      optionList: Object.values(SERVICE_TYPE),
      model: "selector1",
      initialSelection: SERVICE_TYPE.NEW_BORN
    },
    {
      type: FORM_TYPE.SLOT,
      name: "service-note"
    },
    {
      type: FORM_TYPE.HEADER,
      label: "Contact Information:"
    },
    {
      label: "Parent/Guardian 1 First Name: *",
      model: "first_name",
      itemPerRow: 2
    },
    {
      label: "Parent/Guardian 1 Last Name: *",
      model: "last_name",
      itemPerRow: 2
    },
    {
      label: "Parent/Guardian 1 Email: *",
      model: "email",
      itemPerRow: 2,
      validation: [
        {
          regex: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
          message: "Please enter a valid email."
        }
      ]
    },
    {
      label: "Parent/Guardian 1 Phone: *",
      itemPerRow: 2,
      model: "phone"
    },
    {
      label: "Parent/Guardian 1 Occupation: *",
      model: "selector4"
    },
    {
      label: "Parent/Guardian 2 First Name: ",
      model: "selector2",
      itemPerRow: 2,
      isRequired: false,
    },
    {
      label: "Parent/Guardian 2 Last Name: ",
      model: "selector3",
      itemPerRow: 2,
      isRequired: false,
    },
    {
      label: "Parent/Guardian 2 Email: ",
      model: "email2",
      itemPerRow: 2,
      validation: [
        {
          regex: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
          message: "Please enter a valid email."
        }
      ],
      isRequired: false,
    },
    {
      label: "Parent/Guardian 2 Phone: ",
      itemPerRow: 2,
      model: "phone2",
      isRequired: false,
    },
    {
      label: "Parent/Guardian 2 Occupation: ",
      model: "selector5",
      isRequired: false,
    },
    {
      label: "Street Address: *",
      model: "address1"
    },
    {
      label: "Street Address line 2:",
      model: "address2",
      isRequired: false
    },
    {
      label: "City: *",
      itemPerRow: 3,
      model: "city"
    },
    // {
    //   label: "State: *",
    //   itemPerRow: 3,
    //   model: "provincestate"
    // },
    {
      label: "State: *",
      model: "provincestate",
      type: FORM_TYPE.DROPDOWN,
      optionList: americanStates,
      itemPerRow: 3,
      // isRequired: false
    },
    {
      label: "Zip Code: *",
      itemPerRow: 3,
      maxLength: 12,
      inputType: TEXTBOX_INPUT_TYPE.POSITIVE_INTEGER,
      model: "postal_code"
    },
    {
      label: "Best time to reach you? *",
      labelDetail: "Best time to reach me? *",
      model: "selector6",
      showIf: "selector1",
      showIfValue: [
        SERVICE_TYPE.SITTER,
        SERVICE_TYPE.NEW_BORN,
        SERVICE_TYPE.PRIVATE_EDUCATOR
      ]
    },
    {
      label: "If this is a hotel sitting, where will you be staying?",
      labelDetail: "If this is a hotel sitting, where will me be staying?",
      isRequired: false,
      model: "selector7",
      showIf: "selector1",
      showIfValue: SERVICE_TYPE.SITTER
    },
    {
      type: FORM_TYPE.TEXTAREA,
      label: "When do you need the sitter and for how long? *",
      labelDetail: "When do I need the sitter and for how long?",
      model: "text1",
      showIf: "selector1",
      showIfValue: SERVICE_TYPE.SITTER
    },
    {
      type: FORM_TYPE.SLOT,
      name: "children"
    },
    {
      label: "Are you expecting any more children within the next year? *",
      labelDetail: "Am I expecting any more children within the next year?",
      type: FORM_TYPE.RADIO,
      model: "boolean_selector1",
      showIf: "selector1",
      showIfValue: [
        SERVICE_TYPE.NEW_BORN,
        SERVICE_TYPE.NANNY,
        SERVICE_TYPE.PRIVATE_EDUCATOR
      ]
    },
    {
      label: "Desired Start Date: *",
      type: FORM_TYPE.DATEPICKER,
      model: "available_date",
      allowPastDate: false,
      initialView: "month",
      showIf: "selector1",
      showIfValue: [SERVICE_TYPE.NEW_BORN, SERVICE_TYPE.PRIVATE_EDUCATOR]
    },
    {
      type: FORM_TYPE.TEXTAREA,
      label:
        "What qualities and characteristics are you looking for in a Newborn Care Specialist? *",
      labelDetail:
        "What qualities and characteristics am I looking for in a Newborn Care Specialist?",
      showIf: "selector1",
      showIfValue: SERVICE_TYPE.NEW_BORN,
      model: "text2"
    },
    {
      label: "Do you have any Pets? *",
      labelDetail: "Do I have any Pets?",
      type: FORM_TYPE.RADIO,
      model: "boolean_selector2",
      showIf: "selector1",
      showIfValue: [
        SERVICE_TYPE.NEW_BORN,
        SERVICE_TYPE.NANNY,
        SERVICE_TYPE.PRIVATE_EDUCATOR
      ]
    },
    {
      type: FORM_TYPE.TEXTAREA,
      label:
        "How many, the type of pets, size (for dogs please list weight) and whether the caregiver would be responsible for any pet care. *",
      showIf: "boolean_selector2",
      model: "text3"
    },
    {
      label: "Will the nanny be *",
      type: FORM_TYPE.CHECKBOX,
      optionList: [
        "Live-in",
        "Live Out",
        "Weekend, ",
        "Summer/Temporary",
        "Mother’s Helper, ",
        "Traveling Childcare provider",
        "Governess/Private Educator",
        "Household Manager"
      ],
      model: "multiselect1",
      showIf: "selector1",
      showIfValue: SERVICE_TYPE.NANNY
    },
    {
      label: "Which option best describes what you're looking for? *",
      labelDetail: "Which option best describes what I am looking for?",
      type: FORM_TYPE.RADIO,
      optionList: ["Live Out", "Live in", "Traveling"],
      model: "selector19",
      showIf: "selector1",
      showIfValue: SERVICE_TYPE.PRIVATE_EDUCATOR
    },
    {
      label: "Will you need the nanny to *",
      labelDetail: "Will I need the nanny to",
      type: FORM_TYPE.CHECKBOX,
      optionList: [
        "Swim",
        "Drive (Care will be provided)",
        "Drive-(must own car)"
      ],
      model: "multiselect2",
      showIf: "selector1",
      showIfValue: SERVICE_TYPE.NANNY
    },
    {
      type: FORM_TYPE.TEXTAREA,
      label: "What is your desired Weekly Schedule? *",
      labelDetail: "What is my desired Weekly Schedule?",
      model: "text4",
      showIf: "selector1",
      showIfValue: [SERVICE_TYPE.NANNY, SERVICE_TYPE.PRIVATE_EDUCATOR]
    },
    {
      type: FORM_TYPE.TEXTAREA,
      label:
        "What responsibilities will the Private Educator/Governess have? *",
      model: "text9",
      showIf: "selector1",
      showIfValue: SERVICE_TYPE.PRIVATE_EDUCATOR
    },
    {
      type: FORM_TYPE.TEXTAREA,
      label: "What qualities are you looking for in your candidate? *",
      model: "text10",
      showIf: "selector1",
      showIfValue: SERVICE_TYPE.PRIVATE_EDUCATOR
    },
    {
      type: FORM_TYPE.TEXTAREA,
      label: "What responsibilities will the nanny have? *",
      model: "text5",
      showIf: "selector1",
      showIfValue: SERVICE_TYPE.NANNY
    },
    {
      label: "What qualities are you looking for in a nanny? *",
      labelDetail: "What qualities am I looking for in a nanny?",
      type: FORM_TYPE.CHECKBOX,
      optionList: [
        "Cooks for children",
        "does laundry for children",
        "Does laundry for family",
        "Cooks for family",
        "Does Ironing for kids",
        "Helps Children with School work",
        "Help children with remote school work"
      ],
      model: "multiselect3",
      showIf: "selector1",
      showIfValue: SERVICE_TYPE.NANNY
    },
    {
      type: FORM_TYPE.TEXTAREA,
      label: "Any others?",
      isRequired: false,
      model: "text6",
      showIf: "selector1",
      showIfValue: SERVICE_TYPE.NANNY
    },
    {
      label: "Will you need the candidate to *",
      labelDetail: "Will I need the candidate to ",
      type: FORM_TYPE.CHECKBOX,
      optionList: [
        "Swim",
        "Drive (Care will be provided)",
        "Drive-(must own car)"
      ],
      model: "multiselect2",
      showIf: "selector1",
      showIfValue: SERVICE_TYPE.PRIVATE_EDUCATOR
    },
    {
      label: "What accommodations and benefits will you provide the nanny? *",
      labelDetail: "What accommodations and benefits will I provide the nanny?",
      type: FORM_TYPE.CHECKBOX,
      optionList: [
        "Major Holidays Off",
        "Paid Vacation",
        "Paid Travel with family",
        "Bonus",
        "Sick/Mental Health/Personal Days",
        "Private Bathroom",
        "Private Bedroom",
        "Mileage Reimbursement (On-the- job Transportation?",
        "Tuition Reimbursement for Child related course",
        "Health Care Contribution",
        "Cell Phone",
        "401K Contribution"
      ],
      model: "preferences",
      showIf: "selector1",
      showIfValue: [SERVICE_TYPE.NANNY, SERVICE_TYPE.PRIVATE_EDUCATOR]
    },
    {
      label: "Have you ever employed a nanny before? *",
      labelDetail: "Have I ever employed a nanny before? *",
      type: FORM_TYPE.RADIO,
      model: "boolean_selector7",
      showIf: "selector1",
      showIfValue: SERVICE_TYPE.NANNY
    },
    {
      type: FORM_TYPE.TEXTAREA,
      label: "Please tell us what you liked or about your previous nanny *",
      model: "text7",
      showIf: "boolean_selector7"
    },
    {
      label: "Have you employed a Private Educator/Governess before? *",
      labelDetail: "Have I employed a Private Educator/Governess before?",
      type: FORM_TYPE.RADIO,
      model: "boolean_selector9",
      showIf: "selector1",
      showIfValue: SERVICE_TYPE.PRIVATE_EDUCATOR
    },
    {
      type: FORM_TYPE.TEXTAREA,
      label:
        "Please tell us what you liked or disliked about the previous employee? *",
      model: "text7",
      showIf: "boolean_selector9"
    },
    {
      label: "Will a car be provided? *",
      type: FORM_TYPE.RADIO,
      model: "boolean_selector3",
      showIf: "selector1",
      showIfValue: SERVICE_TYPE.NEW_BORN
    },
    {
      label: "Would you consider hiring a person that is not able to drive? *",
      type: FORM_TYPE.RADIO,
      model: "boolean_selector4",
      showIf: "selector1",
      showIfValue: SERVICE_TYPE.NEW_BORN
    },
    {
      label:
        "Would you consider hiring a Newborn Care Specialist outside your location? *",
      type: FORM_TYPE.RADIO,
      model: "boolean_selector5",
      showIf: "selector1",
      showIfValue: SERVICE_TYPE.NEW_BORN
    },
    {
      label: "Are you comfortable paying for their transportation? *",
      type: FORM_TYPE.RADIO,
      model: "boolean_selector6",
      showIf: "boolean_selector5"
    },
    {
      label: "What accommodations and benefits will you provide the NCS? *",
      labelDetail: "What accommodations and benefits will I provide the NCS?",
      type: FORM_TYPE.CHECKBOX,
      model: "multiselect1",
      optionList: [
        "Private Bedroom",
        "Shared Bath",
        "TV",
        "Health Insurance",
        "Paid travel with family",
        "Paid Vacation",
        "Major Holidays Off",
        "Bonus",
        "Meals"
      ],
      showIf: "selector1",
      showIfValue: SERVICE_TYPE.NEW_BORN
    },
    {
      label:
        "Please let us know how long you would have the care provider for *",
      labelDetail:
        "Please let us know how long I would have the care provider for *",
      model: "selector9",
      showIf: "selector1",
      showIfValue: SERVICE_TYPE.NEW_BORN
    },
    {
      label: "Candidate Hourly rate *",
      type: FORM_TYPE.CHECKBOX,
      model: "preferences2",
      optionList: ["$25-29", "$30-35", "$35+"],
      showIf: "selector1",
      showIfValue: [
        SERVICE_TYPE.NEW_BORN,
        SERVICE_TYPE.NANNY,
        SERVICE_TYPE.PRIVATE_EDUCATOR
      ]
    },
    {
      label: "Salary Compensation Range *",
      model: "selector20",
      showIf: "selector1",
      showIfValue: SERVICE_TYPE.PRIVATE_EDUCATOR
    },
    {
      type: FORM_TYPE.TEXTAREA,
      label:
        "Please provide any additional information that can help us in finding your ideal candidate. Do have any teaching styles that you would like them to have? *",
      model: "text10",
      showIf: "selector1",
      showIfValue: SERVICE_TYPE.PRIVATE_EDUCATOR
    },
    {
      label: "Per Day Pay Range: *",
      model: "selector11",
      showIf: "selector1",
      showIfValue: SERVICE_TYPE.NEW_BORN
    },
    {
      label:
        "Do you need us to introduce you to a company to set up payroll for your employee? *",
      type: FORM_TYPE.RADIO,
      model: "boolean_selector8",
      showIf: "selector1",
      showIfValue: SERVICE_TYPE.NANNY
    },
    {
      type: FORM_TYPE.SLOT,
      name: "nanny-form-fee-notice",
      showIf: "selector1",
      showIfValue: SERVICE_TYPE.NANNY
    },
    {
      type: FORM_TYPE.TEXTAREA,
      label:
        "If you have any household pets, please explain (dogs - please list weight)",
      labelDetail: "Explain about any household pets",
      model: "text8",
      isRequired: false,
      showIf: "selector1",
      showIfValue: SERVICE_TYPE.NANNY
    },
    {
      label: "Weekly GROSS Salary Range (estimate) *",
      model: "selector12",
      showIf: "selector1",
      showIfValue: [SERVICE_TYPE.NEW_BORN, SERVICE_TYPE.NANNY]
    },
    {
      label: "Hourly Rate *",
      model: "selector17",
      showIf: "selector1",
      showIfValue: SERVICE_TYPE.NANNY
    },
    {
      label: "Overtime Rate *",
      model: "selector18",
      showIf: "selector1",
      showIfValue: SERVICE_TYPE.NANNY
    },
    {
      label: "How did you hear about Tiny Treasures NYC? *",
      labelDetail: "How did I hear about Tiny Trasures NYC?",
      model: "marketing_source"
    },
    {
      type: FORM_TYPE.CHECKBOX,
      model: "confirm1",
      showIf: "selector1",
      optionList: [
        "Please confirm that you understand that Tiny Treasures Nanny Agency is a household staffing firm that you, the client, is hiring to find vetted and screened professional candidates. The non-refundable registration fee is not the placement fee for finding a candidate. This placement fee is only due if we find you an amazing candidate. Each client will be invoiced based on their search choice. The registration fee will then be credited to the final invoice. This fee is 15%-20% of a candidates gross annual salary. An invoice is sent once you agree to hire our candidate directly or indirectly. Please confirm that you understand our fee schedule."
      ],
      showIfValue: SERVICE_TYPE.NANNY
    },
    {
      type: FORM_TYPE.CHECKBOX,
      model: "confirm1",
      showIf: "selector1",
      optionList: [
        "Please confirm that you understand that Tiny Treasures Nanny Agency is a household staffing firm that you, the client, is hiring to find vetted and screened professional candidates. The non-refundable registration fee is not the placement fee for finding a candidate. This placement fee is only due if we find you an amazing candidate. Each client will be invoiced based on their search choice. The 80% of the registration fee will then be credited to the final invoice. This fee is 15%-20% of a candidates gross annual salary. An invoice is sent once you agree to hire our candidate directly or indirectly. Please confirm that you understand our fee schedule."
      ],
      showIfValue: SERVICE_TYPE.PRIVATE_EDUCATOR
    }
  ]
};

const mutations = {};

const actions = {};

const getters = {
  employerStatuses(state) {
    return state.employerStatuses;
  },
  familyInformationListFields(state) {
    return state.familyInformationListFields;
  },
  childrenListFieldsNewBorn(state) {
    return state.childrenListFieldsNewBorn;
  },
  childrenListFieldsSitter(state) {
    return state.childrenListFieldsSitter;
  },
  childrenListFieldsNanny(state) {
    return state.childrenListFieldsNanny;
  },
  childrenListFieldsPrivateEducator(state) {
    return state.childrenListFieldsPrivateEducator;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/employers.js